export const AppraisalRevisionFormTestIds = {
  TITLE_INPUT: 'appraisal-revision-form.title-input',
  DESCRIPTION_INPUT: 'appraisal-revision-form.description-input',
};
